import {
  GET_ANDROID_BANNER_TOP_BANNER_SUCCESS,
  GET_ANDROID_RECOMMEND_SOFT_SUCCESS,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS,
} from '../constants/arecommend';

const initState = {
  banner: {},
  recommendsSoft: {},
  groupSoft: [],
  groupSoftMore: {},
};

const arecommend = (state = initState, action = {}) => {
  switch (action.type) {
    case GET_ANDROID_BANNER_TOP_BANNER_SUCCESS:
      return { ...state, banner: action.data };
    case GET_ANDROID_RECOMMEND_SOFT_SUCCESS:
      return { ...state, recommendsSoft: action.data };
    case GET_ANDROID_RECOMMEND_GROUP_SOFT_SUCCESS:
      return { ...state, groupSoft: action.data };
    case GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE_SUCCESS:
      return { ...state, groupSoftMore: action.data };
    default:
      return state;
  }
};

export default arecommend;
